/* eslint-disable no-shadow */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import * as arrangeCollectionActions from '../store/actions';
import * as searchAddressActions from
  '../../account/components/AccountTab/components/Address/store/actions';
import * as chooseDeliveryActions from '../../choose-delivery/store/actions';
import * as profileActions from
  '../../account/components/AccountTab/components/MyProfile/store/actions';
import {
  getLoader, getStatus, getTradeCustomer1, getTradeCustomer2, getError, getIsButtonPressed
} from '../store/selectors';
import { getPostcode, getAddresses } from
  '../../account/components/AccountTab/components/Address/store/selectors';
import { getAddress } from
  '../../account/components/AccountTab/components/MyProfile/store/selectors';

import history from '../../../services/history';
import PaperLayout from '../../../components/PaperLayout/PaperLayout';
import { Loader } from '../../../components';
import {
  ArrangeCollection, CollectionStatus, CollectionDetails1, CollectionDetails2
} from '../components';
import { CRAFTY_CLICKS_API_KEY } from '../../../config/apiKeys';
import styles from './styles';


class ArrangeCollectionPage extends React.Component {
  state = { isTradeCustomer: JSON.parse(localStorage.getItem('TradeCustomer')) };

  componentWillMount() {
    this.props.resetAddress();
  }

  componentWillUnmount() {
    this.props.setIsButtonPressed(false);
    this.props.resetError();
    this.props.resetAddress();
  }

  getOrderId = () => {
    const { orderIdFromAccountPage } = this.props;
    const total = JSON.parse(localStorage.getItem('total'));
    const orderId = orderIdFromAccountPage || total.orderId;
    return orderId;
  }

  renderCollectionDetails2 = () => {
    const {
      setIsCollectionArranged,
      tradeCustomer2,
      setFieldForTradeCustomer2,
      changeFieldAddress,
      changeField,
      searchAddress,
      requestSelectedAddress,
      postcode,
      addresses,
      address,
      validatePhoneNumber,
      error,
      resetError,
    } = this.props;

    return (
      <CollectionDetails2
        tradeCustomer={tradeCustomer2}
        setFieldForTradeCustomer={setFieldForTradeCustomer2}
        setFieldForTradeCustomerAddress={changeFieldAddress}
        changeField={changeField}
        searchAddress={searchAddress}
        requestSelectedAddress={requestSelectedAddress}
        postcode={postcode}
        addresses={addresses}
        address={address}
        error={error}
        resetError={resetError}
        onPress={() => {
          setIsCollectionArranged(true);
          validatePhoneNumber(
            {
              key: CRAFTY_CLICKS_API_KEY,
              country: 'gbr',
              phone_number: tradeCustomer2.phoneNumber,
              get_network: true,
            },
            {
              OrderID: this.getOrderId(),
              NumberOfBoxes: tradeCustomer2.boxes,
              PickupDate: tradeCustomer2.date,
              ContactNumber: tradeCustomer2.phoneNumber,
              ...address,
            },
          );
        }}
      />
    );
  }

  renderCollectionDetails1 = () => {
    const {
      setIsCollectionArranged,
      tradeCustomer1,
      setFieldForTradeCustomer1,
      bookCollectionForTrade1,
      orderIdFromAccountPage,
      setIsButtonPressed,
    } = this.props;

    return (
      <CollectionDetails1
        tradeCustomer={tradeCustomer1}
        setFieldForTradeCustomer={setFieldForTradeCustomer1}
        orderIdFromAccountPage={orderIdFromAccountPage}
        onPress={() => {
          setIsCollectionArranged(true);
          setIsButtonPressed(true);
          bookCollectionForTrade1({
            OrderID: this.getOrderId(),
            NumberOfBoxes: tradeCustomer1.boxes,
          });
        }}
        onPressLater={() => history.push('/account/orders')}
      />
    );
  }

  renderArrangeCollectionRequest = () => {
    const {
      requestArrangeCollection,
      setIsCollectionArranged,
      setIsButtonPressed
    } = this.props;

    return (
      <ArrangeCollection
        onPress={() => {
          setIsCollectionArranged(true);
          setIsButtonPressed(true);
          requestArrangeCollection(this.getOrderId());
        }}
      />
    );
  }

  renderRequestStatus = () => {
    const { status, orderIdFromAccountPage } = this.props;

    return (
      <CollectionStatus
        status={status}
        orderIdFromAccountPage={orderIdFromAccountPage}
        onPress={() => {
          history.push({
            pathname: '/account/orders',
            state: { from: 'arrange-collection' }
          });
        }}
      />
    );
  }

  renderContent = () => {
    const { isTradeCustomer } = this.state;
    const { isButtonPressed } = this.props;

    if (isButtonPressed) {
      return this.renderRequestStatus();
    }
    if (isTradeCustomer === 1) {
      return this.renderCollectionDetails1();
    }
    if (isTradeCustomer === 2) {
      return this.renderCollectionDetails2();
    }
    return this.renderArrangeCollectionRequest();
  }

  renderContentWithLoader = () => {
    const { loader } = this.props;

    if (loader) {
      return <Loader />;
    }
    return this.renderContent();
  }


  render() {
    const { orderIdFromAccountPage, isButtonPressed } = this.props;
    const { isTradeCustomer } = this.state;

    return (
      orderIdFromAccountPage
        ? this.renderContentWithLoader()
        : (
          <PaperLayout
            hasBackButton={!isButtonPressed}
            hasSubPaper={false}
            label={
              isTradeCustomer && !isButtonPressed ? 'COLLECTION DETAILS' : 'ARRANGE A COLLECTION'
            }
          >
            {this.renderContentWithLoader()}
          </PaperLayout>
        )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loader: getLoader(state),
    status: getStatus(state),
    tradeCustomer1: getTradeCustomer1(state),
    tradeCustomer2: getTradeCustomer2(state),
    postcode: getPostcode(state),
    addresses: getAddresses(state),
    address: getAddress(state),
    error: getError(state),
    isButtonPressed: getIsButtonPressed(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestArrangeCollection: orderId => dispatch(
      arrangeCollectionActions.requestArrangeCollection(orderId)
    ),
    setIsCollectionArranged: payload => dispatch(
      chooseDeliveryActions.setIsCollectionArranged(payload)
    ),
    setFieldForTradeCustomer1: (field, value) => dispatch(
      arrangeCollectionActions.setFieldForTradeCustomer1(field, value)
    ),
    setFieldForTradeCustomer2: (field, value) => dispatch(
      arrangeCollectionActions.setFieldForTradeCustomer2(field, value)
    ),
    changeFieldAddress: (value, name) => dispatch(profileActions.changeFieldAddress(value, name)),

    changeField: (value, name) => dispatch(searchAddressActions.changeField(value, name)),
    searchAddress: data => dispatch(searchAddressActions.requestAddressSearch(data)),
    requestSelectedAddress: data => dispatch(searchAddressActions.requestSelectedAddress(data)),
    bookCollectionForTrade1: data => dispatch(
      arrangeCollectionActions.bookCollectionForTrade1(data)
    ),
    validatePhoneNumber: (data, dataForNextRequest) => dispatch(
      arrangeCollectionActions.validatePhoneNumber(data, dataForNextRequest)
    ),
    resetAddress: () => dispatch(profileActions.resetAddress()),
    setIsButtonPressed: isButtonPressed => dispatch(
      arrangeCollectionActions.setIsButtonPressed(isButtonPressed)
    ),
    resetError: () => dispatch(arrangeCollectionActions.resetError()),
  };
};

ArrangeCollectionPage.propTypes = {
  requestArrangeCollection: PropTypes.func,
  loader: PropTypes.bool,
  status: PropTypes.bool,
  orderIdFromAccountPage: PropTypes.bool,
  setIsCollectionArranged: PropTypes.func,
  tradeCustomer1: PropTypes.object,
  tradeCustomer2: PropTypes.object,
  setFieldForTradeCustomer1: PropTypes.func,
  setFieldForTradeCustomer2: PropTypes.func,
  changeFieldAddress: PropTypes.func,
  changeField: PropTypes.func,
  searchAddress: PropTypes.func,
  requestSelectedAddress: PropTypes.func,
  postcode: PropTypes.string,
  addresses: PropTypes.array,
  address: PropTypes.object,
  bookCollectionForTrade1: PropTypes.func,
  validatePhoneNumber: PropTypes.func,
  error: PropTypes.string,
  resetAddress: PropTypes.func,
  isButtonPressed: PropTypes.bool,
  setIsButtonPressed: PropTypes.func,
  resetError: PropTypes.func,
};
ArrangeCollectionPage.defaultProps = {
  requestArrangeCollection: () => { },
  loader: false,
  status: false,
  orderIdFromAccountPage: false,
  setIsCollectionArranged: () => { },
  tradeCustomer1: {
    boxes: null,
  },
  tradeCustomer2: {
    date: null,
    address: null,
    boxes: null,
    phoneNumber: null
  },
  setFieldForTradeCustomer1: () => { },
  setFieldForTradeCustomer2: () => { },
  changeFieldAddress: () => { },
  changeField: () => { },
  searchAddress: () => { },
  requestSelectedAddress: () => { },
  postcode: null,
  addresses: [],
  address: {},
  bookCollectionForTrade1: () => { },
  validatePhoneNumber: () => { },
  error: null,
  resetAddress: () => { },
  isButtonPressed: false,
  setIsButtonPressed: () => { },
  resetError: () => { },
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ArrangeCollectionPage));
